import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

export default function initPhotoSwipe() {
  const galleries = document.querySelectorAll('.baum-image-gallery');

  galleries.forEach(gallery => {
    const lightbox = new PhotoSwipeLightbox({
      gallery: gallery,
      children: 'a[data-pswp-src]',
      pswpModule: () => import('photoswipe')
    });

    // Register custom caption UI element
    lightbox.on('uiRegister', function() {
      lightbox.pswp.ui.registerElement({
        name: 'custom-caption',
        order: 9,
        isButton: false,
        appendTo: 'root',
        html: '',
        onInit: (el, pswp) => {
          console.log('ok',el);
          lightbox.pswp.on('change', () => {
            console.log('test',lightbox.pswp.currSlide);
            const currSlideElement = lightbox.pswp.currSlide.data.element;
            let captionHTML = '';
            if (currSlideElement) {
              // Try to find a hidden caption element first
              const hiddenCaption = currSlideElement.querySelector('.hidden-caption-content');
              if (hiddenCaption) {
                captionHTML = hiddenCaption.innerHTML;
              } else {
                // Fallback to alt attribute of the image
                const img = currSlideElement.querySelector('img');
                captionHTML = img ? img.getAttribute('alt') : '';
              }
            }
            console.log(captionHTML);
            el.innerHTML = captionHTML || '';
          });
        }
      });
    });

    lightbox.init();
  });
}

